import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  CardConfiguration,
  IBillingDocument,
  transactionService,
  paymentInfoDisplayService,
  PaymentStatusDisplay,
  IBillingAccount,
  IBillingBalance,
  PaymentStatus,
} from '@dch/billing-business-logic';
import { TranslationService } from '@dch/ng-common';
import { ApplicationState } from 'src/app/state/reducers';
import {
  ODB_DETAILS_SESSION_DATA_KEY,
  UtilsService,
} from '../../services/utils.service';
import { selectCustomerPaymentProfile } from 'src/app/state/selectors/billing-balance.selector';
import { selectCustomerAccount } from 'src/app/state/selectors/customer-account.selector';
import { filter, tap } from 'rxjs/operators';
import {
  COVER_PAGE,
  COVER_NO_DETAILS_PAGE,
} from '../../config/my-bill.constants';
import { OnDestroyHookDirective } from '../../common/hooks';

@Component({
  selector: 'my-bill-transaction-card',
  templateUrl: './my-bill-transaction-card.component.html',
  standalone: false,
})
export class MyBillTransactionCardComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() billingDocument: IBillingDocument;
  @Input() billingAccount: IBillingAccount;
  @Input() balance: string;
  @Input() openTransactionToPayIndex?: number;
  transactionConfiguration: CardConfiguration;
  paymentStatusDisplay: PaymentStatusDisplay;
  paymentTextColour = 'rs-txt-primary';
  warningIcon: string | undefined;

  readonly selectCustomerPaymentProfile$ = this.store.select(
    selectCustomerPaymentProfile
  );

  readonly selectedCustomerAccount$ = this.store.select(selectCustomerAccount);

  constructor(
    private translationService: TranslationService,
    private store: Store<ApplicationState>,
    private router: Router,
    private utilsService: UtilsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.transactionConfiguration = transactionService.configureCard(
      this.billingDocument,
      (key) => this.translationService.getTranslatedValueFor(key)
    );

    this.paymentStatusDisplay =
      paymentInfoDisplayService.getBillingDocumentPaymentStatus(
        (key) => this.translationService.getTranslatedValueFor(key),
        this.billingDocument,
        this.balance
      );
    if (this.billingDocument.paymentStatus === PaymentStatus.ONGOING_PAYMENT) {
      this.paymentTextColour = 'rs-status rs-success';
      this.warningIcon = 'rs-status-icon';
    } else if (this.paymentStatusDisplay.paymentTextColour === 'ERROR') {
      this.paymentTextColour = 'rs-status rs-error';
      this.warningIcon = 'rs-status-icon';
    } else if (this.paymentStatusDisplay.paymentTextColour === 'WARNING') {
      this.paymentTextColour = 'rs-status rs-warning ';
      this.warningIcon = 'rs-status-icon';
    } else if (this.paymentStatusDisplay.paymentTextColour === 'SUCCESS') {
      this.paymentTextColour = 'rs-status rs-success  ';
      this.warningIcon = 'rs-status-icon';
    }
  }

  onClickOnTheCard() {
    this.addSubscription(
      this.selectCustomerPaymentProfile$
        .pipe(
          filter(
            (
              customerPaymentProfile: IBillingBalance['customerPaymentProfile']
            ) => Boolean(customerPaymentProfile)
          ),
          tap((customerPaymentProfile) => {
            this.utilsService.setValueInSessionStorage(
              ODB_DETAILS_SESSION_DATA_KEY,
              {
                billingAccount: this.billingAccount,
                billDocument: this.billingDocument,
                title: this.transactionConfiguration.title,
                subtitle: this.transactionConfiguration.subtitle,
                customerPaymentProfile: customerPaymentProfile,
                isPayButtonVisible: this.billingDocument.payAvailable,
                openTransactionToPayIndex: this.openTransactionToPayIndex,
              }
            );
            this.router.navigate([
              this.billingDocument.showCover
                ? COVER_PAGE
                : COVER_NO_DETAILS_PAGE,
            ]);
          })
        )
        .subscribe()
    );
  }
}
